var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "schoolWarp" },
    [
      _c("ZhjySerach", {
        attrs: { queryGroup: _vm.queryGroup, modelData: _vm.modelData },
        on: {
          "update:modelData": function ($event) {
            _vm.modelData = $event
          },
          "update:model-data": function ($event) {
            _vm.modelData = $event
          },
          search: _vm.listBureau,
        },
      }),
      _vm._v(" "),
      _c("FunBtn", {
        attrs: {
          funBtns: _vm.funBtns,
          defaultColumn: _vm.defaultColumn,
          isShowSelectChange: true,
        },
        on: {
          morePublishout: _vm.morePublishout,
          morePublish: _vm.morePublish,
          delStageGroup: _vm.delStageGroup,
          save: _vm.save,
          modify: _vm.editBureau,
        },
      }),
      _vm._v(" "),
      _c("ZhjyTable", {
        attrs: {
          minWidth: _vm.minWidth,
          tableData: _vm.listData,
          columList: _vm.defaultColumn,
          isShowSelection: true,
          options: _vm.options,
          pageNum: _vm.page.pageNumber,
          pageSize: _vm.page.pageSize,
          formatters: _vm.formatters,
        },
        on: {
          "update:pageNum": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          "update:page-num": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          handleSelectionChange: _vm.handleSelectionChange,
          delStageGroup: _vm.delStageGroup,
          worksSet: _vm.worksSet,
          scoreSet: _vm.scoreSet,
        },
      }),
      _vm._v(" "),
      _c("ZhjyPagination", {
        attrs: {
          pageNum: _vm.page.pageNumber,
          pageSize: _vm.page.pageSize,
          total: _vm.totalData,
        },
        on: {
          "update:pageNum": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          "update:page-num": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          handleCurrentChange: _vm.handleCurrentChange,
          handleSizeChange: _vm.handleSizeChange,
        },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "pubDia",
          attrs: {
            title: "新增组别",
            visible: _vm.addDialog,
            width: "50%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialog = $event
            },
          },
        },
        [
          _c("ZhjyTable", {
            attrs: {
              minWidth: _vm.minWidth,
              tableData: _vm.listData2,
              columList: _vm.defaultColumn2,
              isShowSelection: true,
              options: _vm.options2,
              pageNum: _vm.page2.pageNumber,
              pageSize: _vm.page2.pageSize,
              formatters: _vm.formatters,
            },
            on: {
              "update:pageNum": function ($event) {
                return _vm.$set(_vm.page2, "pageNumber", $event)
              },
              "update:page-num": function ($event) {
                return _vm.$set(_vm.page2, "pageNumber", $event)
              },
              handleSelectionChange: _vm.handleSelectionChange2,
            },
          }),
          _vm._v(" "),
          _c("ZhjyPagination", {
            attrs: {
              pageNum: _vm.page2.pageNumber,
              pageSize: _vm.page2.pageSize,
              total: _vm.totalData2,
            },
            on: {
              "update:pageNum": function ($event) {
                return _vm.$set(_vm.page2, "pageNumber", $event)
              },
              "update:page-num": function ($event) {
                return _vm.$set(_vm.page2, "pageNumber", $event)
              },
              handleCurrentChange: _vm.handleCurrentChange2,
              handleSizeChange: _vm.handleSizeChange2,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "submitBtn" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.subGroup },
                },
                [_vm._v("确定\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.addDialog = false
                    },
                  },
                },
                [_vm._v("取消\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }